import { useContext, useEffect, useRef } from "react";
import clsx from "clsx";
import { User, Settings, Logout, Bell } from "@assets/icons";
import Popup from "@components/Static/Popup";
import NavPopupButton from "@components/Static/Popup/NavPopupButton";
import { UserContext } from "@contexts/User";
import { PROFILE, SETTINGS, NOTIFICATIONS } from "@router/consts";
import { MEDIA_FONT_SIZE } from "@utils/consts";
import {
  PROFILE_GUIDE_STEPS,
  isProfileMenuGuideStep,
} from "@components/NavigationGuide/steps";

const NavbarProfileMenu = ({
  trigger,
  onlineFlag,
  isCounsellor,
  showNotifications,
  htmlFontSize,
  profileId,
  unreadCount,
  onLogout,
  isMobileNav = false,
  mobileMenuTextClass,
}) => {
  const { afterSurveyWrapStep } = useContext(UserContext);
  const popupRef = useRef(null);
  const wasGuiding = useRef(false);
  const isGuidedMenu = isProfileMenuGuideStep(afterSurveyWrapStep);

  useEffect(() => {
    if (isGuidedMenu) {
      popupRef.current?.open();
    } else if (afterSurveyWrapStep || wasGuiding.current) {
      popupRef.current?.close();
    }
    wasGuiding.current = !!afterSurveyWrapStep;
  }, [afterSurveyWrapStep, isGuidedMenu]);

  return (
    <Popup
      ref={popupRef}
      variant="navbar"
      position={isMobileNav ? ["top right"] : ["right bottom"]}
      trigger={trigger}
      closeOnDocumentClick={!isGuidedMenu}
      closeOnEscape={!isGuidedMenu}
      offsetX={isMobileNav ? -8 : 0}
      offsetY={isMobileNav ? 4 : -(htmlFontSize / MEDIA_FONT_SIZE.BASE) * 4}
    >
      <>
        {isCounsellor && onlineFlag}
        <NavPopupButton
          guideTarget={PROFILE_GUIDE_STEPS.DETAILS}
          Icon={() => <User className="fill-current text-dawn-gray" />}
          path={`${PROFILE}/${profileId}`}
          label="navbar.profile"
          textClassName={mobileMenuTextClass}
        />
        {showNotifications && (
          <NavPopupButton
            guideTarget={PROFILE_GUIDE_STEPS.NOTIFICATIONS}
            Icon={Bell}
            path={NOTIFICATIONS}
            label="navbar.notifications.title"
            countBadge={unreadCount > 0 ? unreadCount : null}
          />
        )}
        <NavPopupButton
          guideTarget={PROFILE_GUIDE_STEPS.SETTINGS}
          Icon={Settings}
          path={SETTINGS}
          label="navbar.settings.title"
          textClassName={mobileMenuTextClass}
        />
        <NavPopupButton
          guideTarget={PROFILE_GUIDE_STEPS.LOGOUT}
          Icon={Logout}
          label="navbar.logOut"
          textClassName={clsx("text-pepper", mobileMenuTextClass)}
          onClick={onLogout}
        />
      </>
    </Popup>
  );
};

export default NavbarProfileMenu;
